import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { TokenService } from '@services/helper/token.service';

/**
 * Guard that protects public-only routes (login, register, etc.).
 * Redirects authenticated users to the home page.
 */
export const publicRouteGuard: CanActivateFn = () => {
  const tokenService = inject(TokenService);
  const router = inject(Router);

  /* If token is valid, redirect away from public routes */
  if (tokenService.isTokenValid()) {
    return router.parseUrl('/');
  }

  /* Allow access to public routes */
  return true;
};
